import { render, staticRenderFns } from "./PositionBox.vue?vue&type=template&id=645e1036&scoped=true"
import script from "./PositionBox.vue?vue&type=script&lang=js"
export * from "./PositionBox.vue?vue&type=script&lang=js"
import style0 from "./PositionBox.vue?vue&type=style&index=0&id=645e1036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645e1036",
  null
  
)

export default component.exports